import { app } from '../../../../app';
import { userFromDto } from '../../administrators/administrators.dto';
app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.company-detail', {
        url: '/company-detail?resellerCompanyId',
        component: 'companyResellerCompanyDetail',
        resolve: {
            companyDetails,
            resellerCompanyId,
        }
    })
}


/** @ngInject */
function resellerCompanyId($stateParams) {
    return $stateParams.resellerCompanyId;
}


/** @ngInject */
function companyDetails(ResellerCompanyResource,resellerCompanyId,companyId){
    return ResellerCompanyResource.getCompanyDetail(companyId,resellerCompanyId)
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/reseller-company-detail/reseller-company-detail.state.js